<template>
  <div class="register-wrap">
    <div class="form-wrap">
      <div class="login-title">注册</div>
      <el-form ref="form" :model="form" :rules="rules" inline>
        <el-row>
          <el-form-item prop="mobile">
            <el-input v-model="form.mobile" style="width: 220px" placeholder="手机号码"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="sms_code">
            <el-input v-model="form.sms_code" style="width: 220px" placeholder="验证码">
              <el-button slot="append" type="primary" @click="getCode" :disabled="!!wait">
                <span>{{ wait ? wait : '验证码' }}</span>
              </el-button>
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <el-button type="primary" @click="register">注册</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>

    <el-dialog title="支付后完成注册" :visible.sync="visible" width="340px">
      <img :src="codeImg" alt />
      <p>若支付完成没有跳转到登录页 请自行跳转</p>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'Register',
  data() {
    return {
      form: {
        sms_token: ''
      },
      rules: {
        mobile: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        sms_code: [{ required: true, message: '请输入验证码!', trigger: 'blur' }]
      },
      wait: 0,
      query_nonce: new Date().getTime(),
      codeImg: '',
      visible: false
    }
  },
  created() {
    this.form.sms_token = this.$db.get('sms_token')
    this.init()
  },
  methods: {
    async init() {
      try {
        if (!this.form.sms_token) return
        await this.$confirm('是否已支付')
        this.$router.push('/login')
      } catch (e) {
        this.$db.del('sms_token')
        this.form.sms_token = ''
      }
    },

    //获取验证码
    async getCode() {
      const { data } = await this.$api.post_verify_code(this.form.mobile)
      this.$setInterval(60 * 1000, (count) => (this.wait = count / 1000))
      this.$db.set('sms_token', data.sms_token)
      this.form.sms_token = data.sms_token
    },

    //注册
    async register() {
      try {
        await this.$validate(this.$refs.form)
        if (!this.form.sms_token) return this.$message.info('验证码错误')
        const param = { ...this.form }
        const { data } = await this.$api.post_open_account(param)
        this.$db.del('sms_token')
        await this.openQRCode(data)
      } catch (e) {
        console.log(e)
      }
    },

    async openQRCode(params) {
      this.codeImg = await this.getCodeImg({ query_nonce: this.query_nonce, ...params })
      this.visible = true
      this.polling()
    },

    //生成二维码图片链接
    async getCodeImg(row) {
      const { id: user_id, mobile, query_nonce } = row
      const query = { user_id, mobile, query_nonce }
      const url = `${this.$config.pay_url}?${qs.stringify(query)}`
      return await this.$qrcode(url)
    },

    async polling() {
      const params = { query_nonce: this.query_nonce, no_msg: true }
      await this.$polling(async (polling) => {
        const { data } = await this.$api.get_pay_result_by_noce(params)
        if (data.status !== 'S3999') await polling()
      })
      this.visible = false
      this.$message.success('支付成功!')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-wrap {
  height: 100%;
  text-align: center;
}
</style>
